var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4852 12.75C20.8994 12.75 21.2352 12.4142 21.2352 12C21.2352 11.5858 20.8994 11.25 20.4852 11.25C5.86892 11.25 18.1309 11.25 3.51465 11.25C3.10043 11.25 2.76465 11.5858 2.76465 12C2.76465 12.4142 3.10044 12.75 3.51465 12.75C18.1309 12.75 5.86892 12.75 20.4852 12.75Z",
    fill: "#6633DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusPurple);
export default __webpack_public_path__ + "assets/media/minus-purple.dc64ec47c184659d7d4ce96a2a90f5c4.svg";
export { ForwardRef as ReactComponent };